import * as stylex from "@stylexjs/stylex";
import { motion } from "framer-motion";
import { Popper } from "react-popper";
import { useActiveTheme, useRTL } from "../hooks";
import * as M from "../materials";
import { typography } from "../materials/typography.stylex";
import { Portal } from "./portal";
// -----------------------------------------------------------------------------
// TooltipFlag
const styles = {
    root: {
        kmVPX3: "xxzb6uj",
        kogj98: "x20nx6h",
        kaIpWk: "x1cum3z5",
        khDVqt: "xuxw1ft",
        $$css: true
    },
    title: {
        k63SB2: "x117nqv4",
        $$css: true
    }
};
export const TooltipFlag = ({ title, rows, cx, cy, distance = 0, position = "top", disableInteraction = false })=>{
    const activeTheme = useActiveTheme();
    const isRTL = useRTL();
    const el = new VirtualElement(cx, cy, distance);
    const contrastColor = M.utils.getContrastText(activeTheme.textColor, {
        light: M.whiteText,
        dark: activeTheme.background.dark
    });
    return <Portal>
      <Popper referenceElement={el} placement={position}>
        {({ ref, style, placement, arrowProps })=><motion.div key="tooltip" exit="hidden" initial="hidden" animate="visible" variants={{
            visible: {
                opacity: 1
            },
            hidden: {
                opacity: 0
            }
        }} transition={M.defaultTransition} style={{
            pointerEvents: disableInteraction ? "none" : "all"
        }}>
            <div ref={ref} style={{
            ...style,
            zIndex: M.zIndex.tooltip
        }} data-placement={placement}>
              <div {...stylex.props(typography.meta, styles.root)} style={{
            backgroundColor: activeTheme.textColor,
            color: contrastColor
        }}>
                {title && <div {...stylex.props(typography.meta, styles.title)}>{title}</div>}
                {rows && <div className="x78zum5 xdt5ytf">
                    {rows.map(([left, right], i)=><div key={i} className="x78zum5 x1qughib">
                        <span>{left}</span>
                        <span {...{
                0: {
                    className: "x1tpqehw"
                },
                1: {
                    className: "x1wsuqlk"
                }
            }[!!isRTL << 0]}>
                          {right}
                        </span>
                      </div>)}
                  </div>}
              </div>
              <div ref={arrowProps.ref} style={arrowProps.style}/>
            </div>
          </motion.div>}
      </Popper>
    </Portal>;
};
// -----------------------------------------------------------------------------
// VirtualElement
class VirtualElement {
    bounds;
    constructor(cx, cy, distance){
        this.bounds = {
            top: cy - distance,
            right: cx + distance,
            bottom: cy + distance,
            left: cx - distance,
            width: 2 * distance,
            height: 2 * distance,
            x: cx,
            y: cy,
            toJSON: ()=>this.bounds
        };
    }
    getBoundingClientRect() {
        return this.bounds;
    }
    get clientWidth() {
        return this.getBoundingClientRect().width;
    }
    get clientHeight() {
        return this.getBoundingClientRect().height;
    }
}
